import queryString from "query-string";

import { API_URL } from "constants/api";
import { OrderStatusFilter } from "pages/OrderList/orderStatusFilter";

type Api = {
  url: string;
  method: HttpMethod;
};

export const getPasswordChangedApi = (): Api => ({
  url: `${API_URL}/password/changed`,
  method: "post",
});
export const getGetUserApi = (): Api => ({
  url: `${API_URL}/user`,
  method: "get",
});
export const getGetUsersApi = (): Api => ({
  url: `${API_URL}/user/account/list`,
  method: "get",
});
export const getCreateOrderApi = (): Api => ({
  url: `${API_URL}/order`,
  method: "post",
});
export const getUpdateOrderApi = (orderId: string): Api => ({
  url: `${API_URL}/order/${orderId}`,
  method: "put",
});
export type FindOrdersParams = {
  pageSize: number;
  pageNumber: number;
  contactId?: string;
  orderType: "asc" | "desc";
  searchKeyword?: string;
  orderStatusFilter: OrderStatusFilter;
};
export const getFindOrderApi = (params: FindOrdersParams): Api => ({
  url: `${API_URL}/order?${queryString.stringify(params)}`,
  method: "get",
});
export const getGetOrderApi = (orderId: string): Api => ({
  url: `${API_URL}/order/${orderId}`,
  method: "get",
});
export const getFindEstimateApi = (orderId: string): Api => ({
  url: `${API_URL}/order/${orderId}/estimate`,
  method: "get",
});
export const getAcceptEstimateApi = (orderId: string, estimateId: string): Api => ({
  url: `${API_URL}/order/${orderId}/estimate/${estimateId}/accept`,
  method: "patch",
});
export const getRejectEstimateApi = (orderId: string, estimateId: string): Api => ({
  url: `${API_URL}/order/${orderId}/estimate/${estimateId}/reject`,
  method: "patch",
});
export const getCancelRequestEstimateApi = (orderId: string, estimateId: string): Api => ({
  url: `${API_URL}/order/${orderId}/estimate/${estimateId}/cancel-request`,
  method: "post",
});
export const getFindContractApi = (): Api => ({
  url: `${API_URL}/contract`,
  method: "get",
});

export const getNewsListApi = (params: { pageSize: number; after?: string; before?: string }): Api => ({
  url: `${API_URL}/news?${queryString.stringify(params)}`,
  method: "get",
});

export const getNewsByIdApi = (id: string): Api => ({
  url: `${API_URL}/news/${id}`,
  method: "get",
});
export const getUnreadNewsCountApi = (): Api => ({
  url: `${API_URL}/news/unread/count`,
  method: "get",
});
export const getLatestHomeDisplayNewsApi = (): Api => ({
  url: `${API_URL}/news/homelatest`,
  method: "get",
});
export const updateNewsVisibilityApi = (newsId: string): Api => ({
  url: `${API_URL}/news/${newsId}/visibility`,
  method: "put",
});
